import React from "react";
import { Spinner } from "reactstrap";

const PageLoader = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "60vh" }}
    >
      <Spinner color="primary" />
    </div>
  );
};

export default PageLoader;
